// 初期データの生成関数
function getDefaultState() {
  return {
    // AWS user information for display
    user: null,
  };
}

export default {
  namespaced: true,

  state: getDefaultState(),

  mutations: {
    RESET_STATE(state) {
      // state = etDefaultState()だと"Assignment to function parameter 'state'が発生する"
      Object.assign(state, getDefaultState());
    },
  },

  getters: {},

  actions: {
    resetState({ commit }) {
      commit("RESET_STATE");
    },
    authLogin({ state }, { attributes }) {
      state.auth.user = attributes;
    },
    authLogout({ state }) {
      state.auth.user = null;
    },
  },
};
